import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBlog, FaRobot, FaTasks } from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/editor', icon: <FaTasks />, text: 'Dashboard' },
    { path: '/editor/blogs', icon: <FaBlog />, text: 'Blog Yönetimi' },
    { path: '/editor/automations', icon: <FaRobot />, text: 'Otomasyon Yönetimi' },
  ];

  return (
    <div className="w-64 bg-white shadow-lg h-screen fixed">
      <div className="p-6">
        <h1 className="text-2xl font-bold text-gray-800">Editör Panel</h1>
      </div>
      <nav className="mt-6">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 ${
              location.pathname === item.path ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''
            }`}
          >
            <span className="text-xl mr-3">{item.icon}</span>
            {item.text}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar; 